// src/components/battle/TeamSizeSelect.jsx
export default function TeamSizeSelect({ value, onChange, disabled }) {
  const options = Array.from({ length: 9 }, (_, i) => i + 2);

  return (
    <section className="mb-4 text-sm">
      <label className="block mb-2 font-medium">팀 인원 설정</label>

      <select
        className="w-full rounded-xl border px-4 py-3 bg-gray-50
                   disabled:bg-gray-100 disabled:text-gray-400"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
      >
        <option value="">선택</option>
        {options.map((n) => (
          <option key={n} value={n}>
            {n}명
          </option>
        ))}
      </select>
    </section>
  );
}
